export enum IncidentNibrsVictimType {
    Individual = 'I',
    LawEnforcementOfficer = 'L',
    ReligiousOrganization = 'R',
    Business = 'B',
    FinancialInstitution = 'F',
    Government = 'G',
    Unknown = 'U',
    Other = 'O',
    SocietyPublic = 'S'
}